<template>
  <div class="light" id="app">
    <site-header/>
    <router-view/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import SiteHeader from './Header'
import firstUserAction from '../lib/detect-touch'

export default {
  name: 'App',
  components: { SiteHeader },
  created () {
    firstUserAction(e => {
      if (e.type === 'touchstart') {
        this.setTouchable(true)
      }
    })
  },

  methods: {
    ...mapActions(['setTouchable'])
  }
}
</script>

<style lang="sass">
  @import '../scss/app'
</style>
